import { ICommandBarStyles } from '@fluentui/react/lib/CommandBar';
import { FontWeights, IRawStyle, ITheme } from '@fluentui/react/lib/Styling';
import { ContrastColors, CoreColors, DarkColors } from '../teams-colors';
import { FontSizes } from '../teams-type';

export function getCommandBarStyles(
  themeName: string,
  theme: ITheme
): Partial<ICommandBarStyles> {
  const MS_BUTTON_ICON_SIZE = FontSizes.size14;
  const MS_BUTTON_MENU_ICON_SIZE = FontSizes.size12;
  const MS_COMMAND_BAR_OVERFLOW_BUTTON_SIZE = FontSizes.size16;

  let STATUS_ERROR_FULL_ICON_COLOR = CoreColors.appRed;

  if (themeName === 'dark') {
    STATUS_ERROR_FULL_ICON_COLOR = DarkColors.appRed;
  }
  if (themeName === 'contrast') {
    STATUS_ERROR_FULL_ICON_COLOR = ContrastColors.appRed;
  }

  const STATUS_ERROR_FULL_ICON = {
    "[data-icon-name='StatusErrorFull']": {
      fontWeight: FontWeights.regular,
      color: STATUS_ERROR_FULL_ICON_COLOR
    }
  };

  const COMMANDBAR_HEIGHT = 40;
  const styles = {
    root: {
      height: COMMANDBAR_HEIGHT,
      paddingLeft: '24px',
      paddingRight: '24px',
      background: theme.palette.neutralLighterAlt,
      borderTop: `1px solid ${theme.palette.neutralTertiaryAlt}`,
      borderBottom: `1px solid ${theme.palette.neutralTertiaryAlt}`,
      selectors: {
        '.icons-filled': {
          display: 'none'
        },
        '.icons-unfilled': {
          display: 'block'
        },
        '.icons-default-fill': {
          fill: theme.palette.neutralDark
        },
        '.ms-Button-menuIcon, .ms-Button-icon': {
          color: theme.palette.neutralDark,
          fontSize: MS_BUTTON_ICON_SIZE,
          minWidth: MS_BUTTON_ICON_SIZE,
          lineHeight: '40px',
          height: '40px'
        },
        '.ms-Button-menuIcon': {
          fontSize: MS_BUTTON_MENU_ICON_SIZE,
          minWidth: MS_BUTTON_MENU_ICON_SIZE,
          lineHeight: '40px',
          height: '40px',
          marginLeft: '6px',
          marginTop: '1px'
        },
        '.ms-CommandBarItem-link': {
          textDecoration: 'none'
        },
        'button, a': {
          marginRight: '6px',
          minWidth: 'auto'
        },
        button: {
          height: '100%'
        },
        '.ms-OverflowSet-item:last-child button,  .ms-OverflowSet-item:last-child a': {
          marginRight: '0'
        },
        'a, a:link, a:visited, a:hover, button, button:active, button:hover': {
          background: 'transparent',
          color: theme.palette.neutralDark
        },
        'button[disabled]': {
          color: theme.palette.neutralTertiary
        },
        'button:hover': {
          color: theme.palette.themePrimary,
          selectors: {
            '.icons-default-fill': {
              fill: theme.palette.themePrimary
            },
            '.ms-Button-menuIcon, .ms-Button-icon': {
              fontWeight: 'bold',
              color: theme.palette.themePrimary
            },
            '.icons-filled': {
              display: 'block'
            },
            '.icons-unfilled': {
              display: 'none'
            },
            ...STATUS_ERROR_FULL_ICON
          }
        },
        '.is-expanded': {
          color: theme.palette.themePrimary,
          selectors: {
            '.icons-default-fill': {
              fill: theme.palette.themePrimary
            },
            '.ms-Button-menuIcon, .ms-Button-icon': {
              fontWeight: 'bold',
              color: theme.palette.themePrimary
            },
            '.icons-filled': {
              display: 'block'
            },
            '.icons-unfilled': {
              display: 'none'
            }
          }
        },
        'a:hover': {
          color: theme.palette.themePrimary,
          selectors: {
            '.icons-default-fill': {
              fill: theme.palette.themePrimary
            },
            '.ms-Button-menuIcon, .ms-Button-icon': {
              fontWeight: 'bold',
              color: theme.palette.themePrimary
            },
            '.icons-filled': {
              display: 'block'
            },
            '.icons-unfilled': {
              display: 'none'
            }
          }
        },
        '.ms-CommandBar-overflowButton': {
          minWidth: 'auto',
          selectors: {
            '.ms-Button-menuIcon': {
              margin: 0,
              fontSize: MS_COMMAND_BAR_OVERFLOW_BUTTON_SIZE
            }
          }
        },
        ...STATUS_ERROR_FULL_ICON
      }
    },
    secondarySet: {
      selectors: {
        '.ms-Button-icon': {
          width: 'auto'
        }
      }
    }
  } as Partial<ICommandBarStyles>;

  // Contrast theme overrides
  if (themeName === 'contrast') {
    // Overriding text color
    ((styles.root as Required<IRawStyle>).selectors[
      'a, a:link, a:visited, a:hover, button, button:active, button:hover'
    ] as IRawStyle).color = theme.palette.themeDark;

    // Overriding icons color
    ((styles.root as Required<IRawStyle>).selectors[
      '.ms-Button-menuIcon, .ms-Button-icon'
    ] as IRawStyle).color = theme.palette.themeDark;

    // Overriding svg fill color
    ((styles.root as Required<IRawStyle>).selectors[
      '.icons-default-fill'
    ] as IRawStyle).fill = theme.palette.themeDark;
  }
  return styles;
}
